export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L1_solid_x_01_f.4fda326f.png";